export default __webpack_public_path__ + "static/fa-brands-400-527940b104eb2ea366c8630f3f038603.ttf";